import { MutationTree } from "vuex";
import * as msal from "@azure/msal-browser";
import {
    LOGIN,
    LOGOUT,
    SET_PERMISSION,
} from "./mutations-types";
import { IUserState } from "./state";
import { IPermission } from "@/models";

export const mutations: MutationTree<IUserState> = {

    [LOGIN](state, payload: msal.AccountInfo): void {
        state.account = payload;
    },

    [LOGOUT](state): void {
        // Clear user state
        state.account = null;
    },

    [SET_PERMISSION](state, payload: IPermission) {
        state.permission = payload;
    },
};
